import React, {Suspense, useEffect} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom'
import Translation from './services/translation/translation'
import AppContainer from "./containers/AppContainer";
import CircularProgress from "@material-ui/core/CircularProgress";
import { createTheme } from '@material-ui/core/styles';

import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import {ThemeProvider} from "@material-ui/styles";
import config, { setCountryCode } from "./constants/config";
import { datadogLogs } from '@datadog/browser-logs';

const StageContainer = React.lazy(() => import('./containers/stageContainer'));
const AlreadyRegistered = React.lazy(() => import('./containers/alreadyRegistered'));
const LoginContainer = React.lazy(() => import('./containers/loginContainer'));
const PaymentContainer = React.lazy(() => import('./containers/PaymentMethodsContainer/PaymentMethodsContainer'));
const ThankYou = React.lazy(() => import('./pages/stages/thankYou'));

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const App = (props) => {

    useEffect(() => {
        const { logLevel, ...datadogInitConfig } = config.datadog;
        const env = datadogInitConfig.env;
        if (env.toLocaleLowerCase() == "production") {
            datadogLogs.init(datadogInitConfig);
            datadogLogs.logger.setLevel(logLevel);
        }
    }, []);

    const countryName = document.location.hash.toLowerCase().substring(2, 4) === 'il' ? 'IL' : 'GB';
    (async () => {
        try {
            await Translation.setLanguage(countryName === 'IL' ? 'he' : 'en');
        }
        catch (e){
            console.log(e.message != null ? e.message : "error while set language at init");
        }
    })();

    const direction = Translation.getCurrentLanguage().dir;
    const theme = createTheme({direction});


    document.body.setAttribute('dir', direction);
    return (
        <StylesProvider jss={jss}>
            <ThemeProvider theme={theme}>
                <AppContainer>
                    <div className="app" dir={direction}>
                        <Suspense fallback={<CircularProgress color="inherit" size={30} className="loading-cp"/>}>
                            <Switch>
                                <Route path={'/:country/stage/:appMode/:providerId'}  {...props} component={StageContainer}/>
                                <Route path={'/:country/registered'}  {...props} component={AlreadyRegistered}/>
                                <Route path={'/:country/thank-you'} {...props} component={ThankYou}/>
                                <Route path={'/:country/:appMode/payment-methods/:providerId'} exact {...props}
                                       component={PaymentContainer}/>
                                <Route path={'/:country/login'} {...props} component={LoginContainer}/>
                                <Route path={'/:country'} {...props} component={LoginContainer}/>
                                <Route path={'/'} {...props} component={LoginContainer}/>
                                <Redirect to={'/'}/>
                            </Switch>
                        </Suspense>
                    </div>
                </AppContainer>
            </ThemeProvider>

        </StylesProvider>

    );
}

export default App;
